module.exports = __webpack_public_path__ + "img/violet_129.78fb2ce6.png";